export default {
    title: 'Cloud Server',
    cloud_server: 'Cloud Server',
    service_package: 'កញ្ចប់សេវាកម្ម',
    invoice_id: 'លេខសម្គាល់វិក្ក័យប័ត្រ',
    machine_name: 'ឈ្មោះម៉ាស៊ីន',
    reg_date: 'កាលបរិច្ឆេទចុះឈ្មោះ',
    due_date: 'កាលបរិច្ឆេទ​ផុត​កំណត់',
    enable_backup: 'បើកដំណើរការបម្រុងទុក',
    server_status: 'ស្ថានភាពម៉ាស៊ីនមេ',
    server_package_status: 'ស្ថានភាពកញ្ចប់',
    server_name: 'ឈ្មោះម៉ាស៊ីនមេ',
    project_name: 'ឈ្មោះគម្រោង',
    package_status: 'ស្ថានភាពកញ្ចប់',
    package_name: 'ឈ្មោះកញ្ចប់',
    specifications: 'លក្ខណៈបច្ចេកទេស',
    ip: 'IP សាធារណៈ',
    username: 'ឈ្មោះ​អ្នកប្រើប្រាស់',
    password: 'ពាក្យសម្ងាត់',
    cloud_server_detail: 'ព័ត៌មានលម្អិត Cloud Server',
    dashboard: 'ផ្ទាំងគ្រប់គ្រង',
    cloud_server_info: 'ព័ត៌មាន Cloud Server',
    order_code: 'លេខកូដបញ្ជាទិញ',
    info_management_server: 'ម៉ាស៊ីនមេគ្រប់គ្រងព័ត៌មាន',
    start: 'ចាប់ផ្តើម',
    restart: 'ចាប់ផ្តើមឡើងវិញ',
    shutdown: 'បិទ',
    console: 'កុងសូល។',
    change_os: 'ផ្លាស់ប្តូរ/ដំឡើងប្រព័ន្ធប្រតិបត្តិការឡើងវិញ',
    change_os_alert:
        'ការព្រមាន៖ ប្រសិនបើអ្នកធ្វើដូចនេះ មុខងារ Backup Cloud នឹងត្រូវបានបិទ ហើយម៉ាស៊ីន cloud នេះនឹងមិនអាចប្រើមុខងារស្ដារសម្រាប់ឯកសារបម្រុងទុកចាស់បានទេ។ ឯកសារ បម្រុង ទុក ចាស់ ទាំង នោះ អាច ត្រូវ បាន ប្រើ ដើម្បី បង្កើត cloud ថ្មី។ តើអ្នកប្រាកដថាចង់បន្តទេ?',
    type_os: 'ប្រភេទនៃប្រព័ន្ធប្រតិបត្តិការ',
    version: 'កំណែ',
    new_password: 'ពាក្យសម្ងាត់​ថ្មី',
    extend_cloud_server: 'ពង្រីក Cloud Server',
    additional_ip: 'IP បន្ថែម',
    additional_storage: 'ការផ្ទុកបន្ថែម',
    payment_plan: 'គម្រោងទូទាត់',
    cloud_server_change_os_failed:
        'ការកំណត់រចនាសម្ព័ន្ធ Cloud បរាជ័យ។ សូម ព្យាយាម ម្តង ទៀត។',
    auto_renew: 'បន្តដោយស្វ័យប្រវត្តិ',
    terminal_username: 'ឈ្មោះអ្នកប្រើស្ថានីយ',
    credentials: 'ប័ណ្ណសម្គាល់',
    upgrade_cloud_server: '្វើបច្ចុប្បន្នភាព Cloud Server',
    upgrade_warning:
        'អ្នក ត្រូវ បង់ ប្រាក់ បញ្ជា ទិញ នេះ ក្នុង មួយ ថ្ងៃ បើ មិន ដូច្នេះ ទេ ការ បញ្ជា ទិញ នឹង ត្រូវ បាន លុប',
    change_password: 'ប្ដូរពាក្យសម្ងាត់ Cloud Server',
    change_password_notice: {
        1: 'ការជូនដំណឹងសំខាន់៖ អ្នកហៀបនឹងផ្លាស់ប្តូរពាក្យសម្ងាត់សម្រាប់ម៉ាស៊ីន Cloud Server របស់អ្នក។',
        2: 'យើងចង់ជូនដំណឹងដល់អ្នកថាដំណើរការនេះនឹងបណ្តាលឱ្យបាត់បង់ទិន្នន័យនៅក្នុងថតអ្នកប្រើប្រាស់របស់អ្នក (e.g., {ubuntuUserDir} នៅលើ Ubuntu ឬ {windowsUserDir} នៅលើ Windows)។',
        3: 'យើងធានានូវភាពប្រាកដប្រជានៃការជូនដំណឹងនេះ និងសូមកោតសរសើរចំពោះកិច្ចសហប្រតិបត្តិការរបស់អ្នក។ សូមអរគុណ!',
    },
    backup_name: 'ឈ្មោះបម្រុងទុក',
    restore_cloud_server: {
        title: 'ស្តារ Cloud Server',
        confirm_title: 'តើអ្នកចង់ស្ដារ {packageName} ពី {backupName} ដែរឬទេ?',
        confirm_des:
            'ប្រតិបត្តិការនេះនឹងសរសេរជាន់លើទិន្នន័យម៉ាស៊ីនមេដោយប្រើការបម្រុងទុកខាងក្រោម។ ការចាប់ផ្តើមមួយ ការស្ដារឡើងវិញមិនអាចលុបចោលបានទេ។',
    },
    disable_backup: {
        title: 'បិទដំណើរការបម្រុងទុក',
        confirm_title: 'តើអ្នកចង់បិទការបម្រុងទុកទេ?',
    },
    backup_list: {
        history_backup: 'ប្រវត្តិនៃការបម្រុងទុក',
        backup_name: 'ឈ្មោះបម្រុងទុក',
        created_date: 'កាលបរិច្ឆេទបង្កើត',
    },
    schedule_backup: 'កាលវិភាគបម្រុងទុក',
    schedule_displayed: 'ការបម្រុងទុកត្រូវបានកំណត់ពេលចាប់ផ្តើម',
    cron_expression: 'Cron expression',
    cron_run_at: 'ការងារ cron របស់អ្នកនឹងដំណើរការនៅ',
    backup_will_be_enabled: 'ការបម្រុងទុកនឹងត្រូវបានបើកដំណើរការ',
    backup_management: {
        title: 'ម៉ាស៊ីនបម្រើគ្រប់គ្រងការបម្រុងទុក',
        enable_backup: {
            title: 'តោះចាប់ផ្តើមបម្រុងទុក Cloud server របស់អ្នក។',
            description:
                'ការបម្រុងទុកបង្កើតច្បាប់ចម្លងប្រចាំសប្តាហ៍នៃ Cloud Server របស់អ្នកដោយស្វ័យប្រវត្តិ។{lineBreak}ពួកវាអាចត្រូវបានប្រើសម្រាប់ការស្ដារទិន្នន័យដែលបាត់បង់ ឬខូច និងបង្កើត Cloud Server ថ្មី។',
            description_price:
                'ការបម្រុងទុកសម្រាប់ Cloud Server នេះមានតម្លៃ {price}/ដង។',
        },
        disable_backup: {
            title: 'ការបម្រុងទុកត្រូវបានបើកដំណើរការ',
            description:
                'ពួកវាត្រូវបានរក្សាទុកនៅ {numberOfCopies} ភាគច្រើន ហើយអាចត្រូវបានស្ដារឡើងវិញសម្រាប់ការប្រើប្រាស់បន្ថែមទៀត។',
            description_price:
                'ការបម្រុងទុកសម្រាប់ Cloud Server នេះមានតម្លៃ {price}/ដង។',
        },
    },
    cloud_addons: {
        cpu: 'vCPU',
        ram: 'Ram',
        storage: 'Storage',
        bandwidth: 'Bandwidth',
        os: 'OS',
    },
    cores: 'cores',
};
